<form action="" [formGroup]="myForm">
  <div class="row content-filter">
    <mat-form-field [ngClass]="transformClass()" *ngIf="isDepartment">
      <mat-label>{{!isModuleNV ? 'Seleccionar departamento/provincia' : 'Seleccionar departamento/provincia *'}}</mat-label>
      <input
        matInput
        id="department"
        formControlName="department"
        [matAutocomplete]="department"
      />
      <mat-autocomplete
        #department="matAutocomplete"
        [displayWith]="displayFn"
      >
        <mat-option value="TODOS" id="itemAll" *ngIf="!isModuleNV">
          <span> TODOS </span>
        </mat-option>
        <mat-option
          *ngFor="
            let option of listDepartmentAsync | async;
            let i = index
          "
          [value]="{department: option.department, id: option.id }"
          [id]="'department-' + i"
        >
          <span> {{ option.department }} </span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field [ngClass]="transformClass()" *ngIf="isProvince">
      <mat-label>{{!isModuleNV ? 'Seleccionar provincia/cantones' : 'Seleccionar provincia/cantones *'}}</mat-label>
      <input
        matInput
        id="province"
        formControlName="province"
        [matAutocomplete]="province"
      />
      <mat-autocomplete
        #province="matAutocomplete"
        [displayWith]="displayFn"
      >
        <mat-option value="TODOS" id="itemAll"  *ngIf="!isModuleNV">
          <span> TODOS </span>
        </mat-option>
        <mat-option
          *ngFor="
            let option of listProvinceAsync | async;
            let i = index
          "
          [value]="{province: option.province, id: option.id }"
          [id]="'province-' + i"
        >
          <span> {{ option.province }} </span>
        </mat-option>
      </mat-autocomplete>
      </mat-form-field>
    <mat-form-field [ngClass]="transformClass()" *ngIf="isDistrict">
        <mat-label>{{!isModuleNV ? 'Seleccionar distrito/parroquia' : 'Seleccionar distrito/parroquia *'}}</mat-label>
        <input
          matInput
          id="district"
          formControlName="district"
          [matAutocomplete]="district"
        />
        <mat-autocomplete
          #district="matAutocomplete"
          [displayWith]="displayFn"
        >
          <mat-option value="TODOS" id="itemAll" *ngIf="!isModuleNV">
            <span> TODOS </span>
          </mat-option>
          <mat-option
            *ngFor="
              let option of listDistrictAsync | async;
              let i = index
            "
            [value]="{district: option.district, id: option.ubigeoCode }"
            [id]="'district-' + i"
          >
            <span> {{ option.district }} </span>
          </mat-option>
        </mat-autocomplete>
    </mat-form-field>
  </div>
</form>

